module.exports = __webpack_public_path__ + "img/spotify.78a444c8.jpg";